module.exports = __webpack_public_path__ + "img/autonivelante_de_fraguado_rapido.7db33781.png";